module.exports = __webpack_public_path__ + "img/title_game_features.5995671c.jpg";